export default __webpack_public_path__ + "static/glow-teacher-a4c9beaf0afc3762ccc55937a2984697.svg";